import { render } from "./GeralRating.vue?vue&type=template&id=47208afe&scoped=true"
import script from "./GeralRating.vue?vue&type=script&lang=js"
export * from "./GeralRating.vue?vue&type=script&lang=js"

import "./GeralRating.vue?vue&type=style&index=0&id=47208afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47208afe"]])

export default __exports__